import { render, staticRenderFns } from "./policyDocumentInfo.vue?vue&type=template&id=2b7b5eca&scoped=true&"
import script from "./policyDocumentInfo.vue?vue&type=script&lang=js&"
export * from "./policyDocumentInfo.vue?vue&type=script&lang=js&"
import style0 from "./policyDocumentInfo.vue?vue&type=style&index=0&id=2b7b5eca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7b5eca",
  null
  
)

export default component.exports